/* eslint-disable no-debugger */
import { Fragment } from 'react';

import usePaymentComplete from './UsePaymentComplete';

import ShoppingCartLoadingModal from '../../components/dialogs/ShoppingCartLoadingModal';

import PrimaryButton from '../../../buttons/PrimaryButton';
import SecondaryButton from '../../../buttons/SecondaryButton';
import CustomerSatisfaction from '../../components/inputs/CustomerSatisfaction';

/**
 * Sub view that is displayed after a successful payment transaction.
 * @param {Function} onReturnClicked optional return button
 */
const PaymentComplete = ({ onReturnClicked }) => {
  const {
    isLoading,
    hasReceipt,
    isPending,
    onBackToCartClicked,
    onDownloadReceiptClicked,
    paymentsShoppingCartState
  } = usePaymentComplete();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          {hasReceipt === true
            ? <p>Your payment was successful.</p>
            : isPending === true
              ? <p>Your payment was successful. You will be able to view your receipt from your dashboard once your payment has finished processing.</p>
              : <p>Your payment was successful. You can view your receipt from your dashboard.</p>
          }
        </div>
      </div>
      <div className='row usas-extra-top-margin'>
        <div className="col-xs-12">
          {hasReceipt === true &&
            <Fragment><PrimaryButton type="button" onClick={() => onDownloadReceiptClicked()}>Download Receipt</PrimaryButton>&nbsp;</Fragment>
          }
          {onReturnClicked
            ? <SecondaryButton type="button" onClick={onReturnClicked}>Return</SecondaryButton>
            : <SecondaryButton type="button" onClick={() => onBackToCartClicked()}>Back To Cart</SecondaryButton>
          }
        </div>
      </div>
      <ShoppingCartLoadingModal isLoading={isLoading} />
      <div className="row">
        <div className="col-xs-12">
          <CustomerSatisfaction 
            count={5}
            iconSize={40} 
            defaultRating={0} 
            icon={''}
            dataKeyName={'stripeId'}
            dataKeyValue={paymentsShoppingCartState.checkoutPageData?.stripeId}
            customerSatisfactionId={-1}
            helpText='How would you rate your overall experience with this process?'
          />
        </div>
      </div>
    </Fragment>
  );
};

export default PaymentComplete;